import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_GB',
  {
    fdidYouMean: true,
    ffacetNavigation: true,
    fdomainSuggestions: true,
    fvideo: true,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: true,
    frelatedsearch: true,
  },
  {
    fssInputCategory: true,
  },
  '261e6520-c85e-40d4-b233-1ace4c23930a',
  ''
);
